import React, { Component, Fragment } from 'react';
import {connect} from "react-redux";
import {IRootState} from "../../store";
import DispatchProps from "../../utils/DispatchProps";
import CDBBlogViewer from "../cdb-blog-viewer/CDBBlogViewer";
import {match} from "react-router";
import SchoolMenu from '../SchoolMenu';

interface HomePageProps {
    userIsCdbEmployee: boolean,
    userIsTenantManager: boolean,

    match: match<{tenantId?: string,schoolCode?: string}>;
}

class HomePage extends Component<HomePageProps & DispatchProps ,any> {
    static displayName = HomePage.name;

    constructor(props: HomePageProps & DispatchProps) {
        super(props);

        this.state = {

        }
    }

    async componentDidMount() {
    }
    
    async componentDidUpdate(prevProps: Readonly<HomePageProps & DispatchProps>, prevState: Readonly<any>, snapshot?: any) {
        
    }
    
    render () {        
        return (
            <Fragment>
                <SchoolMenu prefix="Home" />
                <div className={"cdb-admin-content cdb-admin-content--column"}>
                    <CDBBlogViewer />
                </div>
            </Fragment>
        );
    }
}

export default connect(
    (state: IRootState,ownProps: {match: match<{tenantId?: string,schoolCode?: string}>}): HomePageProps => {
        return {
            match: ownProps.match,
            userIsCdbEmployee: state.auth.userIsCdbEmployee,
            userIsTenantManager: state.schools.userIsTenantManager,
        };
    }
)(HomePage)